import { useFormContext } from 'react-hook-form';
import { Input } from '@/components/ui/input';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { InvitationFormValues } from '@/types/invitation-schema';

// El itinerario se gestiona en la pestaña "Detalles" (`sections.itinerario`, con catálogo de
// momentos), que es el que se renderiza en la invitación. Aquí solo va el lugar de la fiesta.
const LocationsTab = () => {
  const form = useFormContext<InvitationFormValues>();

  return (
    <div className="grid gap-6">
      <Card>
        <CardHeader>
          <CardTitle>Fiesta / Recepción</CardTitle>
          <CardDescription>Lugar de la celebración</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="grid gap-4 md:grid-cols-2">
            <FormField
              control={form.control}
              name="party_name"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Nombre del lugar</FormLabel>
                  <FormControl>
                    <Input placeholder="Hacienda Los Robles" {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name="party_time"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Hora</FormLabel>
                  <FormControl>
                    <Input type="time" {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
          </div>
          <FormField
            control={form.control}
            name="party_address"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Dirección</FormLabel>
                <FormControl>
                  <Input placeholder="Km 5 Carretera al Norte" {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name="party_map_url"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Link de Google Maps</FormLabel>
                <FormControl>
                  <Input placeholder="https://maps.google.com/..." {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        </CardContent>
      </Card>
    </div>
  );
};

export default LocationsTab;
